import { render, staticRenderFns } from "./pbi.vue?vue&type=template&id=f574edc0&scoped=true&"
import script from "./pbi.vue?vue&type=script&lang=js&"
export * from "./pbi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f574edc0",
  null
  
)

export default component.exports